import { FeatureFlagKey } from '@/features/feature-flags/presentation/types/feature-flag-key';
import { Configuration } from './types';

export const config: Partial<Configuration> = {
  portalApi: 'https://api.uat.ewa.wa.gov.au/v1',
  portalEwaBffApi: 'https://api.preflight.portal.genvis.com/ewa/v1',
  mapbox: {
    defaultStyle: 'mapbox://styles/robgenvis/cmizqxrq9006201r81qml3b97',
    satelliteStyle: 'mapbox://styles/robgenvis/cmizqz3k4006301sn591b269u',
    overlaysTileSet: 'mapbox://robgenvis.ewa-overlays-dev',
    overlayTileSetLayers: {
      dfesRegions: 'dfes-regions-tileset-layer-dev',
      lga: 'lga-tileset-layer-dev',
      lgaCentres: 'lga-centres-tileset-layer-dev',
      pastoralStations: 'pastoral-stations-tileset-layer-dev',
      fdrRegions: 'fdr-regions-cr69-tileset-layer-dev',
      fdrCenters: 'fdr-centres-cr69-tileset-layer-dev',
    },
  },
  remoteHazardAssets: {
    iconAssetsPathSvg: 'https://preflight.kudo.genvis.com/assets/icons/map/pins',
    iconAssetsPathPng: 'https://preflight.kudo.genvis.com/assets/icons/map/pins/40x40',
  },
  geospatialBucket: 'https://dbqyqh98zsjbu.cloudfront.net',
  webTemplateStyleSheetUrl: 'https://preflight.kudo.genvis.com/assets/styles/ewa-webtemplate.css',
  sentry: {
    dsn: 'https://2946dfe99e66df21f5f92a4655a0b647@o4507253793816576.ingest.de.sentry.io/4507255077339216',
    enabled: true,
  },
  featureFlags: {
    [FeatureFlagKey.EnableMyEmergencyPlan]: true,
  },
  firebaseConfig: {
    apiKey: 'AIzaSyCvLFftZziqVJLJkXSjFZ8msT5oGU0lTLU',
    authDomain: 'ewa-web-preflight.firebaseapp.com',
    projectId: 'ewa-web-preflight',
    storageBucket: 'ewa-web-preflight.firebasestorage.app',
    messagingSenderId: '248996364316',
    appId: '1:248996364316:web:9cf4fd3d9ec46400f29fd9',
    measurementId: 'G-LCG9Y2PEFM',
  },
  recaptcha: {
    siteKey: '6LfYxrwrAAAAAAL4fq7NV6Gyt5agQIkY3Br3CMPG',
    enabled: true,
  },
  // TODO: Configure GTM for preflight-uat
  googleTagManager: {
    containerId: 'GTM-PZWL43P8',
  },
  environment: 'preflight-uat',
};
